import { useTranslation } from '@wix/wix-i18n-config';
import React from 'react';

import { templatePreviewModalDataHooks } from '../TemplatePreviewModal.dataHooks';
import s from './ErrorBanner.scss';
import Alert from './Alert.svg';
import Close from './Close.svg';

type Props = {
  onTryAgainClick: () => void;
  onCloseClick: () => void;
};

export const ErrorBanner: React.FC<Props> = ({
  onTryAgainClick,
  onCloseClick,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={s.errorBanner}
      data-hook={templatePreviewModalDataHooks.errorBanner()}
    >
      <div className={s.content}>
        <Alert className={s.icon} />
        <span className={s.text}>
          {t('app.templates.ChooseTemplate.ErrorBanner.text')}
        </span>
        <button className={s.tryAgainButton} onClick={onTryAgainClick}>
          {t('app.templates.ChooseTemplate.ErrorBanner.tryAgainButton.text')}
        </button>
      </div>
      <button className={s.closeButton} onClick={onCloseClick}>
        <Close />
      </button>
    </div>
  );
};
